import { MedplumClient } from "@medplum/core";
import { QuestionnaireResponse } from "@medplum/fhirtypes";

import {
  buildLaborAmendEncounterQuestionnaireItems,
  mergeQuestionnaireResponseItemsByLinkId,
} from "@/encounters/components/EncounterLabor/utils/labor-amend-encounter-questionnaire-items";
import { applyEncounterQuestionnaireResponseAmendmentVersioning } from "@/encounters/utils/encounter-questionnaire-response-extensions";
import { EncounterAmendmentFormType } from "@/encounters/zod-schemas/encounter-answers";

export interface SaveLaborAmendEncounterQuestionnaireResponseParams {
  medplum: MedplumClient;
  questionnaireResponse: QuestionnaireResponse;
  parsedValues: EncounterAmendmentFormType;
}

/**
 * Applies labor amend form values to the encounter QuestionnaireResponse and persists to Medplum.
 */
export async function saveLaborAmendEncounterQuestionnaireResponse({
  medplum,
  questionnaireResponse,
  parsedValues,
}: SaveLaborAmendEncounterQuestionnaireResponseParams): Promise<QuestionnaireResponse> {
  const amendmentItems = buildLaborAmendEncounterQuestionnaireItems(parsedValues);
  const updatedItems = mergeQuestionnaireResponseItemsByLinkId(
    questionnaireResponse.item ?? [],
    amendmentItems,
  );

  const updatedQuestionnaireResponse = applyEncounterQuestionnaireResponseAmendmentVersioning({
    ...questionnaireResponse,
    status: "amended",
    item: updatedItems,
  });

  const savedQuestionnaireResponse = await medplum.updateResource(updatedQuestionnaireResponse);

  medplum.invalidateSearches("QuestionnaireResponse");
  medplum.invalidateSearches("Encounter");
  medplum.invalidateSearches("Observation");

  return savedQuestionnaireResponse;
}
